/**
 * @file        src/pages/hotel/CorporateCancellationList.jsx
 * @description Corporate Hotel → Cancellation List. Same list as the B2C Hotel
 *              Cancellation List (CancellationList.jsx), fixed to audience=b2b,
 *              instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Hotel menu parity with B2C).
 */
import CancellationList from './CancellationList';

export default function CorporateCancellationList() {
  return (
    <CancellationList
      title="Corporate Cancellation List"
      subtitle="Corporate Hotel · cancellations & refunds"
      audience="b2b"
    />
  );
}
